<div class="signup-tap">
  <app-text class="desktop-view" [class]="'signup-text'" (textClick)="showSignup($event)">
    Sign up
  </app-text>

</div>
